<template>
  <a-checkbox-group v-model="checkedList" :options="options" @change="onChange" />
</template>

<script>
import mixin from '../mixin/AExtStringMixin'
import {xxx as initApi} from '../../../api/api'
export default {
    name: "index",
    mixins:[mixin],
    data() {
        return {
            checkedList:[],
            options:[],
            localValue: ''
        }
    },
    created(){
      this.init();
    },
    methods:{
        init(){
            initApi("key").then(result => {
                if (result.data && result.data.succ) {
                    this.options = result.data.data;
                }
            }).catch(() => {
                this.options=[];
            });
            if(this.localValue)
            {
              this.checkedList=this.localValue.split(",");
            }
            else {
                this.checkedList=[];
            }
        },
        onChange(checkedList)
        {
          this.localValue=checkedList.join(',');
        }
    }

}
</script>

<style scoped>

</style>